import { render, staticRenderFns } from "./pccontactus.vue?vue&type=template&id=527c77bf"
import script from "./pccontactus.vue?vue&type=script&lang=js"
export * from "./pccontactus.vue?vue&type=script&lang=js"
import style0 from "./pccontactus.vue?vue&type=style&index=0&id=527c77bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports